import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
let promise = Promise.all([parcelRequire.load("kQzNc")]).then(() => {
let originalModule = parcelRequire("91ZFR");
let resources = <link rel="modulepreload" href={parcelRequire.resolve("kQzNc")} />;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
